export const platformName = "阳泉高新技术产业开发区企业公共服务平台";
export const showTopMenu = false;
export const leftMenuConfigOptions = {
  rootValue: "1628606141145972737",
  keyField: "menuId",
  parentField: "parentId",
  nameField: "menuName",
  pathField: "identifier",
  urlPrefixField: "urlPrefix",
  menuCodeField: "menuCode",
};

// export const leftMenuConfigOptions = {
//     rootValue: 1628606141145972737,
//     keyField: 'key',
//     parentField: 'parentId',
//     nameField: 'name',
//     pathField: 'identifier',
//     urlPrefixField: 'urlPrefix',
//     iconField: 'icon',
// }
